import React from "react";
// Vee Manage Flow Modal

// Mui
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// Custom
import ContainedButton from "../../forms/button/ContainedButton";

// Redux
import { setVeeRuleWorkflow } from "../../redux/features/VeeSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

const VeeManageFlowModal = ({
  onLoadFlow,
  onClose,
  setToast,
  open,
}: {
  onLoadFlow: (flow: any) => void;
  onClose: () => void;
  setToast: (toast: any) => void;
  open: boolean;
}) => {
  const { veeRuleWorkflow } = useAppSelector((state) => state.vee);

  const dispatch = useAppDispatch();

  const deleteFlow = (flowName: any) => {
    const updatedFlows = veeRuleWorkflow?.filter(
      (flow) => flow?.name !== flowName?.name
    );
    dispatch(setVeeRuleWorkflow(updatedFlows));
    setToast({
      message: `Flow "${flowName?.name}" deleted successfully!`,
      severity: "success",
    });
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: "500px",
          maxWidth: "none",
        },
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>Manage Flows</DialogTitle>
        <IconButton onClick={onClose} sx={{ marginRight: "10px" }}>
          <CloseIcon />
        </IconButton>
      </Stack>

      <DialogContent dividers>
        {veeRuleWorkflow?.length === 0 && (
          <Typography
            variant="body1"
            fontSize={"16px"}
            fontWeight={500}
            textAlign={"center"}
            padding={"10px 0"}
          >
            {" "}
            No saved flows available.
          </Typography>
        )}

        {veeRuleWorkflow?.map((flow, index) => {
          return (
            <Box
              key={index}
              sx={{
                border: "1px solid #D7DAE7",
                padding: "16px",
                borderRadius: "10px",
                boxShadow: 1,
                mb: 2,
              }}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography variant="body1" fontSize={"16px"} fontWeight={600}>
                  {flow?.name}
                </Typography>

                <Stack direction={"row"} gap={"5px"} alignItems={"center"}>
                  <ContainedButton
                    label={"Load"}
                    sx={{
                      fontWeight: 600,
                      color: "#ffffff",
                    }}
                    onClick={() => onLoadFlow(flow)}
                  />

                  <ContainedButton
                    label={"Delete"}
                    bgColor={
                      "linear-gradient(180deg, #FF7F7F 0%, #FF4D4D 100%)"
                    }
                    sx={{
                      fontWeight: 600,
                      color: "#ffffff",
                    }}
                    onClick={() => deleteFlow(flow)}
                  />
                </Stack>
              </Stack>
            </Box>
          );
        })}

        <DialogActions sx={{ padding: "20px 0 0 0" }}>
          <ContainedButton
            label={"Close"}
            bgColor={"linear-gradient(180deg, #FF7F7F 0%, #FF4D4D 100%)"}
            sx={{
              fontWeight: 600,
              color: "#ffffff",
            }}
            onClick={onClose}
          />
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default VeeManageFlowModal;
